export default {
    storageKeys: {
        // Will contains the "cache" recommendation result
        reco: 'reco',
        reco_98f1216da0b24011a0ecc3f334e637e1: 'reco_98f1216da0b24011a0ecc3f334e637e1',
        reco_b3c77690182a4f53b7f82e9c81539827: 'reco_b3c77690182a4f53b7f82e9c81539827',
        reco_060cb45f6ddf4329a76dbc039f52ad15: 'reco_060cb45f6ddf4329a76dbc039f52ad15',
        reco_81af49ad75994ebd8daa391b9b471d2f: 'reco_81af49ad75994ebd8daa391b9b471d2f',
        reco_5b4e6b9c8a50429597ae8f1f17122e1a: 'reco_5b4e6b9c8a50429597ae8f1f17122e1a',
        reco_4d938fb0226d48d78cefde15bad2c6a3: 'reco_4d938fb0226d48d78cefde15bad2c6a3',
        reco_fe85981d6a2d46d8bc1c1a31244bf421: 'reco_fe85981d6a2d46d8bc1c1a31244bf421',

        // Will contains the timestamp of the last recommendation retrieval
        lastRecoRetrieval: 'lastRecoRetrieval',
        lastRecoRetrieval_98f1216da0b24011a0ecc3f334e637e1:
            'lastRecoRetrieval_98f1216da0b24011a0ecc3f334e637e1',
        lastRecoRetrieval_b3c77690182a4f53b7f82e9c81539827:
            'lastRecoRetrieval_b3c77690182a4f53b7f82e9c81539827',
        lastRecoRetrieval_060cb45f6ddf4329a76dbc039f52ad15:
            'lastRecoRetrieval_060cb45f6ddf4329a76dbc039f52ad15',
        lastRecoRetrieval_81af49ad75994ebd8daa391b9b471d2f:
            'lastRecoRetrieval_81af49ad75994ebd8daa391b9b471d2f',
        lastRecoRetrieval_5b4e6b9c8a50429597ae8f1f17122e1a:
            'lastRecoRetrieval_5b4e6b9c8a50429597ae8f1f17122e1a',
        lastRecoRetrieval_4d938fb0226d48d78cefde15bad2c6a3:
            'lastRecoRetrieval_4d938fb0226d48d78cefde15bad2c6a3',
        lastRecoRetrieval_fe85981d6a2d46d8bc1c1a31244bf421:
            'lastRecoRetrieval_fe85981d6a2d46d8bc1c1a31244bf421',
    },
    useSlotNumber: false,
}
